import { yup } from "@utils/validation/validation";

export const LanguageOverridesSchema = yup.object().shape({
  original: yup.string().trim().max(2000),
  overriden: yup.string().trim().max(2000),
});
